import React from 'react';
import { Grid, Box, Typography, Link, Tooltip } from '@mui/material';
import { Form, Spacer } from 'src/components/shared';
import InfoIcon from '@mui/icons-material/Info';

export default function AutomatedEmailValidation({ tenantSettings, id, ...props }) {
  const styles = {
    container: {
      height: '80%',
      marginTop: '0px',
    },
    infoIcon: {
      fill: 'rgba(0, 0, 0, 0.26)',
      width: 20,
      marginTop: 17,
    },
    link: {
      '&:hover': { color: '#1976D2' },
      position: 'relative',
      textDecoration: 'none',
      '&::after': {
        content: '""',
        position: 'absolute',
        left: 0,
        bottom: '0px',
        width: '100%',
        height: '1px',
        backgroundColor: '#1976D2',
      },
    },
  };

  const getSwitchValue = (mode) => {
    return (
      tenantSettings?.emailVerificationSettings?.enabled &&
      tenantSettings?.emailVerificationSettings?.mode === mode
    );
  };

  const updateEmailVerificationSettings = async (mode, isEnabled) => {
    const settings = {
      id: id || '',
      emailVerificationSettings: {
        enabled: isEnabled,
        mode: mode,
      },
    };
    await props.updateSettings(settings);
  };

  const TitleBar = ({ title, tooltip }) => (
    <Box display="flex" alignItems="center">
      <Typography variant="h4">{title}</Typography>
      {tooltip && tooltip !== '' && (
        <>
          <Spacer y={1} x={0.5} />
          <Tooltip title={tooltip}>
            <InfoIcon style={styles.infoIcon} />
          </Tooltip>
        </>
      )}
    </Box>
  );

  return (
    <Box style={styles.container}>
      <Form
        initialValues={{
          addEmail: getSwitchValue('addEmail'),
          sendEmail: getSwitchValue('sendEmail'),
        }}
        enableReinitialize={true}
      >
        <Grid display="flex" flexDirection="column" container>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="body2" color="textSecondary">
                Validate emails using a third party service. This is a paid service, and charges
                apply for usage.{' '}
                <Link
                  component="button"
                  type="button"
                  onClick={() => window.open('/admin/billing/subscriptions', '_blank')}
                  underline="none"
                  color="#1976D2"
                  sx={styles.link}
                >
                  Add Funds
                </Link>
              </Typography>
            </Grid>
          </Grid>
          <Grid spacing={1} display="flex" mt={1} ml={1.5}>
            <Form.Field.Switch
              name="addEmail"
              onChange={(val) => {
                updateEmailVerificationSettings('addEmail', val);
              }}
              label="when primary email added"
            />
            <TitleBar tooltip="Your email will be validated once you add a primary email address." />
          </Grid>
          <Grid spacing={1} display="flex" mt={1} ml={1.5}>
            <Form.Field.Switch
              name="sendEmail"
              onChange={(val) => {
                updateEmailVerificationSettings('sendEmail', val);
              }}
              label="when sending an email"
            />
            <TitleBar tooltip="Your email address will be validated the first time you send an email to it." />
          </Grid>
        </Grid>
      </Form>
    </Box>
  );
}
